import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getPendingReceivedRequests } from '../api/social';
import { getChallengeInvites } from '../api/challenges';
import { getHotPotatoUnreadCount } from '../api/hotPotato';
import {
  HomeIcon,
  ChallengesIcon,
  LogIcon,
  AchievementsIcon,
  ProfileIcon,
} from '../assets/icons';
import '../styles/BottomNav.css';

const BottomNav = () => {
    const history = useHistory();
    const location = useLocation();
    const [pendingCount, setPendingCount] = useState(0);
    const [hotPotatoUnreadCount, setHotPotatoUnreadCount] = useState(0);
    const [challengeInviteCount, setChallengeInviteCount] = useState(0);

    useEffect(() => {
        const fetchPending = async () => {
            try {
                const data = await getPendingReceivedRequests();
                const requests = Array.isArray(data.received_requests) ? data.received_requests : [];
                setPendingCount(requests.length);
            } catch (err) {
                // silently ignore
            }
        };
        const fetchHotPotatoUnread = async () => {
            try {
                const data = await getHotPotatoUnreadCount();
                setHotPotatoUnreadCount(Number(data.unread_count) || 0);
            } catch (err) {
                // silently ignore
            }
        };
        const fetchChallengeInvites = async () => {
            try {
                const data = await getChallengeInvites();
                setChallengeInviteCount(Array.isArray(data) ? data.length : 0);
            } catch (err) {
                // silently ignore
            }
        };
        fetchPending();
        fetchHotPotatoUnread();
        fetchChallengeInvites();
    }, [location.pathname]);

    const profileBadgeCount = pendingCount + hotPotatoUnreadCount;

    const isActive = (path) => {
        if (path === '/dashboard') {
            return location.pathname === '/dashboard' || location.pathname.startsWith('/activity/');
        }
        return location.pathname === path;
    };

    return (
        <nav className="bottom-nav">
            <button
                className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}
                onClick={() => {
                    if (location.pathname === '/dashboard') {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    } else {
                        history.push('/dashboard');
                    }
                }}
            >
                <span className="nav-icon">
                    <HomeIcon />
                </span>
                <span className="nav-label">Home</span>
            </button>

            <button
                className={`nav-item ${isActive('/challenges') ? 'active' : ''}`}
                onClick={() => history.push('/challenges')}
            >
                <span className="nav-icon nav-icon-profile">
                    <ChallengesIcon />
                    {challengeInviteCount > 0 && <span className="nav-badge">{challengeInviteCount}</span>}
                </span>
                <span className="nav-label">Challenges</span>
            </button>

            <button
                className={`nav-item action-btn ${isActive('/log-activity') ? 'active' : ''}`}
                onClick={() => history.push('/log-activity')}
            >
                <span className="action-icon">
                    <LogIcon />
                </span>
                <span className="nav-label">Log</span>
            </button>

            <button
                className={`nav-item ${isActive('/achievements') ? 'active' : ''}`}
                onClick={() => history.push('/achievements')}
            >
                <span className="nav-icon">
                    <AchievementsIcon />
                </span>
                <span className="nav-label">Achievements</span>
            </button>

            <button
                className={`nav-item ${isActive('/profile') ? 'active' : ''}`}
                onClick={() => history.push('/profile')}
            >
                <span className="nav-icon nav-icon-profile">
                    <ProfileIcon />
                    {profileBadgeCount > 0 && <span className="nav-badge">{profileBadgeCount}</span>}
                </span>
                <span className="nav-label">Profile</span>
            </button>
        </nav>
    );
};

export default BottomNav;
